<template>
  <div
    class="subsection"
  >
    <template v-if="editing">
      <div class="subsection-edit">
        <slot name="active" />
        <div class="active-subsection-btn-group">
          <button
            class="save-btn"
            :disabled="disabledSave"
            @click="$emit('active-action')"
          >
            <transition
              name="btn-slide"
              mode="out-in"
            >
              <icon
                v-if="activeBtnType === 'icon'"
                class="btn-icon"
                name="check"
                variant="mastery"
              />
              <span
                v-else
                class="btn-text"
              >{{ activeBtnText }}</span>
            </transition>
          </button>
          <button
            class="cancel-btn"
            @click="$emit('cancel-action')"
          >
            Cancel
          </button>
          <slot name="active-disabled" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="subsection-display">
        <slot name="inactive" />
      </div>
      <button
        v-if="showAction"
        :disabled="disabled"
        :class="['subsection-action', {'danger-action': actionType === 'danger'}]"
        @click="$emit('inactive-action')"
      >
        {{ actionText }}
      </button>
    </template>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    actionText: {
      type: String,
      default: 'Edit',
    },
    actionType: {
      type: String,
      default: '',
    },
    activeBtnText: {
      type: String,
      default: 'Save',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledSave: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    sectionName: {
      type: String,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    activeBtnType: {
      type: String,
      default: 'text',
    },
  },
};
</script>

<style lang="scss" scoped>
.subsection {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: rem-calc(28) 0 rem-calc(28) rem-calc(12);

  &:first-child {
    padding-top: 0;
  }

  &:not(:first-child) {
    border-top: 1px solid #e1e7ef;
  }

  button {
    background: inherit;
  }

  .subsection-display {
    p {
      margin: rem-calc(2) 0 0;

      &.disabled {
        color: #989898;
      }

      &:not(:first-child) {
        margin-top: rem-calc(24);
      }
    }

    span {
      &.disabled {
        color: #989898;
      }
    }
  }

  .subsection-edit {
    input {
      box-sizing: border-box;
      display: block;
      max-width: rem-calc(340);
      width: 100%;
      min-width: rem-calc(200);
      margin-bottom: rem-calc(8);
      border-radius: 4px;
      border: 1px solid #d3d3d3;
      padding: rem-calc(8) rem-calc(12);
      font-size: inherit;

      @include focus-not-visible {
        &:focus {
          border-color: #00d8f8;
        }
      }

      &.icon-input {
        padding-right: rem-calc(24);
      }

      &:disabled {
        background-color: #f9f9f9;
      }
    }

    // Labels for screen reader purposes moved off screen
    label.hidden {
      position: absolute;
      left: -10000px;
    }

    .active-subsection-btn-group {
      display: block;
      margin-top: rem-calc(20);
    }

    .btn-slide-enter-active,
    .btn-slide-leave-active {
      transition: all .5s ease-out;
    }
    .btn-slide-enter {
      transform: translateX(40px);
      opacity: 0;
    }
    .btn-slide-leave-to {
      transform: translateX(-40px);
      opacity: 0;
    }

    .save-btn,
    .cancel-btn {
      font-size: rem-calc(14);
      padding: rem-calc(8) rem-calc(28);
      vertical-align: middle;
    }

    .save-btn {
      background-color: #00d8f8;
      color: white;
      border-radius: 4px;
      font-weight: $semi-bold;
      margin-right: rem-calc(30);

      .btn-text {
        height: rem-calc(16);
        display: block;
      }

      .btn-icon {
        height: rem-calc(16);
        background-color: #ffffff;
        border-radius: 50%;
        display: block;
        margin: 0 auto;
      }

      &:disabled {
        opacity: .25;
      }
    }

    .cancel-btn {
      background: transparent;
    }

    .date-picker ~ .active-subsection-btn-group {
      margin-left: rem-calc(106);
      margin-top: rem-calc(12);

      @include breakpoint(medium) {
        margin-left: 0;
      }
    }
  }

  .subsection-action {
    color: #00d8f8;
    float: right;
    padding: 0;
    background: transparent;
    text-align: right;

    &.danger-action {
      color: #ee1300;
    }

    &:first-child {
      margin-left: auto;
    }

    &:disabled {
      opacity: .25;
    }

    &:hover:not(:disabled) {
      text-decoration: underline;
    }
  }
}
</style>
